import React, {useEffect, useRef, useState} from 'react';


import Box from "@mui/material/Box";
import { InputLabel, Select, Stack, TextField} from "@mui/material";
import Button from "@mui/material/Button";
import {useForm} from "react-hook-form";


import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {useDispatch, useSelector} from "react-redux";
import {
    getContractLengths,
    getGuilds, getJobCodes
} from "./StakeholderListClient";
import {changeStakeholderListSearch} from "./stakeholderListSearchSlice";
import {changeStakeholderList} from "./stakeholderListSlice";
import FormDatePicker from "../../CommonComponents/FormDatePicker";
import CircularProgressOverlay from "../../CommonComponents/CircularProgressOverlay";




export default function StakeholderListSearch({gridClear}) {

    const selectorSubmitting = useSelector((state) => state.externalDataSlc.value.submitting);

    const { register, handleSubmit, control, setValue, reset } = useForm();
    // const {register, handleSubmit} = useForm();
    const [guildDropdown, setGuildDropdown] = useState([]);
    const [selectedGuild, setSelectedGuild] = useState('');
    const [jobCodeDropdown, setJobCodeDropdown] = useState([]);
    const [selectedJobCode, setSelectedJobCode] = useState('');
    const [contractLengthDropdown, setContractLengthDropdown] = useState([]);
    const [selectedContractLength, setSelectedContractLength] = useState('');
    const setupsDropdown = ["","Has","None"];
    const [selectedParticipations, setSelectedParticipations] = useState('');
    const [selectedResiduals, setSelectedResiduals] = useState('');
    const [selectedRoyalties, setSelectedRoyalties] = useState('');
    const [stakeholderListValue, setStakeholderListValue] = useState([]);
    const dispatchData = useDispatch();
    const [stakeholderLists, setStakeholderLists] = useState([]);

    const handleClearClick = () => {
        setStakeholderListValue("");
    };

    const handleClearStakeholderListClick = () => {
        setStakeholderListValue("");
    };


    const fetchGuilds = () => {
        getGuilds()

            .then(data => {
                console.log("Guilds");
                console.log(data);
                console.log("Guilds with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setGuildDropdown(data);
            })}


    const fetchJobCodes = () =>
        getJobCodes()

            .then(data => {
                console.log("Job Codes");
                console.log(data);
                console.log("Job Codes with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setJobCodeDropdown(data);
            });

    const fetchContractLengths = () =>
        getContractLengths()

            .then(data => {
                console.log("Contract Lengths");
                console.log(data);
                console.log("Contract Lengths with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setContractLengthDropdown(data);
            })

    useEffect(() => {
        console.log("This is for the M4mkt Group dropdown...");
        fetchGuilds();
        fetchJobCodes();
        fetchContractLengths();
    }, []);


    function onSubmit(data) {
        console.log("here's my stakeholderList search data before I submit it ")
        console.log({data});
        dispatchData(changeStakeholderListSearch({
            // searchData: data
            fileId: data.fileId,
            recordId: data.recordId,
            productId: data.productId,
            productName: data.productName,
            episodeName: data.episodeName,
            photoStartDateFrom: data.photoStartDateFrom,
            photoStartDateTo: data.photoStartDateTo,
            seriesExternalId: data.seriesExternalId,
            seriesName: data.seriesName,
            seasonExternalId: data.seasonExternalId,
            seasonNumberFrom: data.seasonNumberFrom,
            seasonNumberTo: data.seasonNumberTo,
            seasonName: data.seasonName,
            guild: data.guild,
            fsoId: data.fsoId,
            fsoTaxId: data.fsoTaxId,
            fsoFirstName: data.fsoFirstName,
            fsoLastName: data.fsoLastName,
            fsoSuffix: data.fsoSuffix,
            contractedPartyId: data.contractedPartyId,
            contractedPartyTaxId: data.contractedPartyTaxId,
            contractedPartyFirstName: data.contractedPartyFirstName,
            contractedPartyLastName: data.contractedPartyLastName,
            contractedPartySuffix: data.contractedPartySuffix,
            contractedPartyCompanyName: data.contractedPartyCompanyName,
            payeeId: data.payeeId,
            payeeTaxId: data.payeeTaxId,
            payeeFirstName: data.payeeFirstName,
            payeeLastName: data.payeeLastName,
            payeeSuffix: data.payeeSuffix,
            payeeCompanyName: data.payeeCompanyName,
            jobCode: data.jobCode,
            contractLength: data.contractLength,
            participations: data.participations,
            residuals: data.residuals,
            royalties: data.royalties
        }));
        dispatchData(changeStakeholderList({
            stakeholderListGridRefresh: true
        }));
    };


    const handleClear = () => {

        reset({
            fileId: '',
            recordId: '',
            productId: '',
            productName: '',
            episodeName: '',
            photoStartDateFrom: '',
            photoStartDateTo: '',
            seriesExternalId: '',
            seriesName: '',
            seasonExternalId: '',
            seasonNumberFrom: '',
            seasonNumberTo: '',
            seasonName: '',
            guild: '',
            fsoId: '',
            fsoTaxId: '',
            fsoFirstName: '',
            fsoLastName: '',
            fsoSuffix: '',
            contractedPartyId: '',
            contractedPartyTaxId: '',
            contractedPartyFirstName: '',
            contractedPartyLastName: '',
            contractedPartySuffix: '',
            contractedPartyCompanyName: '',
            payeeId: '',
            payeeTaxId: '',
            payeeFirstName: '',
            payeeLastName: '',
            payeeSuffix: '',
            payeeCompanyName: '',
            jobCode: '',
            contractLength: '',
            participations: '',
            residuals: '',
            royalties: ''
        });

        setSelectedGuild('');
        setSelectedJobCode('');
        setSelectedContractLength('');
        setSelectedParticipations('');
        setSelectedResiduals('');
        setSelectedRoyalties('');

        gridClear()
    };

    const handleGuildChange = (guildEvent) => {
        setSelectedGuild(guildEvent.target.value);
        console.log("This is for the selected Value");
        console.log(guildEvent.target.value);
    };


    const handleJobCodeChange = (jobCodeEvent) => {
        setSelectedJobCode(jobCodeEvent.target.value);
        console.log("This is for the selected Value");
        console.log(jobCodeEvent.target.value);
    };


    const handleContractLengthChange = (contractLengthEvent) => {
        setSelectedContractLength(contractLengthEvent.target.value);
        console.log("This is for the selected Value");
        console.log(contractLengthEvent.target.value);
    };



    const handleParticipationsChange = (participationsEvent) => {
        setSelectedParticipations(participationsEvent.target.value);
        console.log("This is for the selected Value");
        console.log(participationsEvent.target.value);
    };

    const handleResidualsChange = (residualsEvent) => {
        setSelectedResiduals(residualsEvent.target.value);
        console.log("This is for the selected Value");
        console.log(residualsEvent.target.value);
    };

    const handleRoyaltiesChange = (royaltiesEvent) => {
        setSelectedRoyalties(royaltiesEvent.target.value);
        console.log("This is for the selected Value");
        console.log(royaltiesEvent.target.value);
    };

    const selectR2mRef = useRef();


    const searchForm  = () => (
        <form
            onSubmit={handleSubmit((data)=>        onSubmit(data))}
        >
            <Box
                sx={{height: 740, pl: 5}}
                role="presentation"
            >
                <Stack direction={"Horizontal"} sx={{pb: 1}}>
                    {/*<InputLabel htmlFor="id">ID</InputLabel>*/}
                    <TextField variant="filled"
                               {...register('fileId', {required: false})}
                               id="fileId" name="fileId" label="File ID" aria-describedby="fileId_entry"
                               sx={{width: 160, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('recordId', {required: false})}
                               id="recordId" name="recordId" label="Record ID" aria-describedby="recordId_entry"
                               sx={{width: 160, pr: 5}}/>
                </Stack>
                <Stack direction={"horizontal"} sx={{pb: 1}}>
                    <TextField variant="filled"
                               {...register('productId', {required: false})}
                               id="productId" name="productId" label="Product ID" aria-describedby="productId_entry"
                               sx={{width: 160, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('productName', {required: false})}
                               id="productName" name="productName" label="Product Name"
                               aria-describedby="productName_entry"
                               sx={{width: 300, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('episodeName', {required: false})}
                               id="episodeName" name="episodeName" label="Episode Name"
                               aria-describedby="episodeName_entry"
                               sx={{width: 300, pr: 5}}/>
                    <FormDatePicker
                        name="photoStartDateFrom"
                        label="Photo From"
                        control={control}
                        width={200}
                    />
                    <FormDatePicker
                        name="photoStartDateTo"
                        label="Photo To"
                        control={control}
                        width={200}
                    />
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('photoStartDateFrom', {required: false})}*/}
                    {/*           id="photoStartDateFrom" name="photoStartDateFrom" label="Photo From"*/}
                    {/*           aria-describedby="photoStartDateFrom_entry"*/}
                    {/*           sx={{width: 150, pr: 5}}/>*/}
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('photoStartDateTo', {required: false})}*/}
                    {/*           id="photoStartDateTo" name="photoStartDateTo" label="Photo To"*/}
                    {/*           aria-describedby="photoStartDateTo_entry"*/}
                    {/*           sx={{width: 150, pr: 5}}/>*/}

                </Stack>
                <Stack direction={"horizontal"} sx={{pb: 1}}>
                    <TextField variant="filled"
                               {...register('seriesExternalId', {required: false})}
                               id="seriesExternalId" name="seriesExternalId" label="Series ID"
                               aria-describedby="seriesExternalId_entry"
                               sx={{width: 160, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('seriesName', {required: false})}
                               id="seriesName" name="seriesName" label="Series Name" aria-describedby="seriesName_entry"
                               sx={{width: 300, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('seasonExternalId', {required: false})}
                               id="seasonExternalId" name="seasonExternalId" label="Season ID"
                               aria-describedby="seasonExternalId_entry"
                               sx={{width: 160, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('seasonNumberFrom', {required: false})}
                               id="seasonNumberFrom" name="seasonNumberFrom" label="# From"
                               aria-describedby="seasonNumberFrom_entry"
                               sx={{width: 140, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('seasonNumberTo', {required: false})}
                               id="seasonNumberTo" name="seasonNumberTo" label="# To"
                               aria-describedby="seasonNumberTo_entry"
                               sx={{width: 140, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('seasonName', {required: false})}
                               id="seasonName" name="seasonName" label="Season Name" aria-describedby="seasonName_entry"
                               sx={{width: 300}}/>
                </Stack>
                <Stack direction={"horizontal"} sx={{pb: 1}}>
                    <FormControl variant="standard" sx={{pr: 5, minWidth: 100}}>
                        <InputLabel sx={{ml: 1}} htmlFor="guild">Guild</InputLabel>
                        <Select
                            {...register('guild', {required: false})}
                            labelId="demo-simple-select-filled-guild"
                            id="guild"
                            variant="filled"
                            value={selectedGuild}
                            label="guild"
                            onChange={handleGuildChange}
                            sx={{width: 300}}
                        >
                            {guildDropdown.map((guildItem) =>
                                <MenuItem FreeSolo={true}
                                          value={guildItem.singleField} key={guildItem.singleField}
                                >{guildItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <FormControl variant="standard" sx={{ml: 1, pr: 5, minWidth: 300}}>
                        <InputLabel sx={{ml: 1}} htmlFor="jobCode">Job Code</InputLabel>
                        <Select
                            {...register('jobCode', {required: false})}
                            labelId="demo-simple-select-filled-jobCode"
                            id="jobCode"
                            variant="filled"
                            label="jobCode"
                            value={selectedJobCode}
                            onChange={handleJobCodeChange}
                            sx={{width: 300}}
                        >
                            {jobCodeDropdown.map((jobCodeItem) =>
                                <MenuItem
                                          value={jobCodeItem.singleField} key={jobCodeItem.singleField}
                                >{jobCodeItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <FormControl variant="standard" sx={{pr: 5, minWidth: 200}}>
                        <InputLabel sx={{ml: 1}} htmlFor="contractLength">Contract Length</InputLabel>
                        <Select
                            {...register('contractLength', {required: false})}
                            labelId="demo-simple-select-filled-contractLength"
                            id="contractLength"
                            variant="filled"
                            label="contractLength"
                            value={selectedContractLength}
                            onChange={handleContractLengthChange}
                            sx={{width: 200}}
                        >
                            {contractLengthDropdown.map((contractLengthItem) =>
                                <MenuItem
                                          value={contractLengthItem.singleField} key={contractLengthItem.singleField}
                                >{contractLengthItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                </Stack>
                <p>For Services Of (FSO)</p>
                <Stack direction={"Horizontal"} sx={{pb: 1}}>
                    <TextField variant="filled"
                               {...register('fsoId', {required: false})}
                               id="fsoId" name="fsoId" label="ID" aria-describedby="fsoId_entry"
                               sx={{width: 160, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('fsoTaxId', {required: false})}
                               id="fsoTaxId" name="fsoTaxId" label="Tax ID" aria-describedby="fsoTaxId_entry"
                               sx={{width: 160, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('fsoFirstName', {required: false})}
                               id="fsoFirstName" name="fsoFirstName" label="First Name"
                               aria-describedby="fsoFirstName_entry"
                               sx={{width: 160, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('fsoLastName', {required: false})}
                               id="fsoLastName" name="fsoLastName" label="Last Name"
                               aria-describedby="fsoLastName_entry"
                               sx={{width: 160, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('fsoSuffix', {required: false})}
                               id="fsoSuffix" name="fsoSuffix" label="Suffix" aria-describedby="fsoSuffix_entry"
                               sx={{width: 160, pr: 5}}/>
                </Stack>
                <p>Contracted Party</p>
                <Stack direction={"Horizontal"} sx={{pb: 1}}>
                    <TextField variant="filled"
                               {...register('contractedPartyId', {required: false})}
                               id="contractedPartyId" name="contractedPartyId" label="ID"
                               aria-describedby="contractedPartyId_entry"
                               sx={{width: 160, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('contractedPartyTaxId', {required: false})}
                               id="contractedPartyTaxId" name="contractedPartyTaxId" label="Tax ID"
                               aria-describedby="contractedPartyTaxId_entry"
                               sx={{width: 160, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('contractedPartyFirstName', {required: false})}
                               id="contractedPartyFirstName" name="contractedPartyFirstName" label="First Name"
                               aria-describedby="contractedPartyFirstName_entry"
                               sx={{width: 160, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('contractedPartyLastName', {required: false})}
                               id="contractedPartyLastName" name="contractedPartyLastName" label="Last Name"
                               aria-describedby="contractedPartyLastName_entry"
                               sx={{width: 160, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('contractedPartySuffix', {required: false})}
                               id="contractedPartySuffix" name="contractedPartySuffix" label="Suffix"
                               aria-describedby="contractedPartySuffix_entry"
                               sx={{width: 160, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('contractedPartyCompanyName', {required: false})}
                               id="contractedPartyCompanyName" name="contractedPartyCompanyName" label="Company Name"
                               aria-describedby="contractedPartyCompanyName_entry"
                               sx={{width: 200, pr: 5}}/>
                </Stack>
                <p>Payee</p>
                <Stack direction={"Horizontal"} sx={{pb: 1}}>
                    <TextField variant="filled"
                               {...register('payeeId', {required: false})}
                               id="payeeId" name="payeeId" label="ID" aria-describedby="payeeId_entry"
                               sx={{width: 160, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('payeeTaxId', {required: false})}
                               id="payeeTaxId" name="payeeTaxId" label="Tax ID" aria-describedby="payeeTaxId_entry"
                               sx={{width: 160, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('payeeFirstName', {required: false})}
                               id="payeeFirstName" name="payeeFirstName" label="First Name"
                               aria-describedby="payeeFirstName_entry"
                               sx={{width: 160, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('payeeLastName', {required: false})}
                               id="payeeLastName" name="payeeLastName" label="Last Name"
                               aria-describedby="payeePartyLastName_entry"
                               sx={{width: 160, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('payeeSuffix', {required: false})}
                               id="payeeSuffix" name="payeeSuffix" label="Suffix" aria-describedby="payeeSuffix_entry"
                               sx={{width: 160, pr: 5}}/>
                    <TextField variant="filled"
                               {...register('payeeCompanyName', {required: false})}
                               id="payeeCompanyName" name="payeeCompanyName" label="Company Name"
                               aria-describedby="payeeCompanyName_entry"
                               sx={{width: 200, pr: 5}}/>
                </Stack>
                <br/>
                <br/>
                <Stack direction={"Horizontal"} sx={{pb: 1}}>
                    <FormControl variant="standard" sx={{pr: 5, minWidth: 200}}>
                        <InputLabel sx={{ml: 1}} htmlFor="participations">Participations</InputLabel>
                        <Select
                            {...register('participations', {required: false})}
                            labelId="demo-simple-select-filled-participations"
                            id="participations"
                            FreeSolo={true}
                            variant="filled"
                            label="participations"
                            value={selectedParticipations}
                            onChange={handleParticipationsChange}
                            sx={{width: 200}}
                        >
                            {setupsDropdown.map((setupsItem) =>
                                <MenuItem FreeSolo={true} value={setupsItem} key={setupsItem}
                                >{setupsItem}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" sx={{pr: 5, minWidth: 200}}>
                        <InputLabel sx={{ml: 1}} htmlFor="residuals">Residuals</InputLabel>
                        <Select
                            {...register('residuals', {required: false})}
                            labelId="demo-simple-select-filled-residuals"
                            id="residuals"
                            FreeSolo={true}
                            variant="filled"
                            label="residuals"
                            value={selectedResiduals}
                            onChange={handleResidualsChange}
                            sx={{width: 200}}
                        >
                            {setupsDropdown.map((setupsItem) =>
                                <MenuItem FreeSolo={true} value={setupsItem} key={setupsItem}
                                >{setupsItem}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" sx={{pr: 5, minWidth: 200}}>
                        <InputLabel sx={{ml: 1}} htmlFor="royalties">Royalties</InputLabel>
                        <Select
                            {...register('royalties', {required: false})}
                            labelId="demo-simple-select-filled-royalties"
                            id="royalties"
                            FreeSolo={true}
                            variant="filled"
                            label="royalties"
                            value={selectedRoyalties}
                            onChange={handleRoyaltiesChange}
                            sx={{width: 200}}
                        >
                            {setupsDropdown.map((setupsItem) =>
                                <MenuItem FreeSolo={true} value={setupsItem} key={setupsItem}
                                >{setupsItem}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <Button
                        type="submit"
                    >RETRIEVE</Button>
                    <Button onClick={handleClear}
                    >CLEAR</Button>
                </Stack>
            </Box>
        </form>
    );

    return (
        <Box sx={{ position: 'relative' }}>
            {searchForm()}
            {selectorSubmitting && <CircularProgressOverlay/>}
        </Box>

    )


}

